<script setup lang="ts">

import Translator from "@/utils/common/Translator";
import SearchIcon from "@/components/icons/navBarIcons/SearchIcon.vue";
import {useTemplateRef} from "vue";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import SideBarUtils from "@/utils/common/SideBarUtils.ts";

const value = defineModel();
const props = defineProps({
  id: {
    required: true,
    type: String
  }
})
const inputRef = useTemplateRef<HTMLInputElement>("inputRef");

function focusSearchInput() {
  document.getElementById(props.id)?.focus();
}

function onKeyDown(event: KeyboardEvent) {
  if (event.key === 'Escape') {
    value.value = null;
    inputRef.value?.blur();
    if (!SideBarUtils.isSidebarFixed())
      useNamaFlagsStore().isSideBarOpen = false;
  }
}

</script>

<template>
  <div class="tw-mb-0">
    <div class="tw-relative tw-leading-tight">
      <span class="tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-justify-center tw-items-center tw-pl-3" @click="focusSearchInput">
            <SearchIcon/>
      </span>
      <input
        ref="inputRef" @keydown="onKeyDown"
        class="tw-border-none tw-bg-[#F8F9FA] tw-shadow tw-appearance-none tw-rounded-md tw-w-full tw-py-2 tw-pl-12  tw-text-gray-700
          focus:tw-ring-0 focus:tw-outline-none focus:tw-shadow-outline
          dark:tw-bg-[#383838] dark:hover:tw-bg-[#383838] dark:tw-text-namaFontColor-input-dark dark:tw-placeholder-gray-300" autocomplete="off"
        :id="id" type="text" :placeholder="Translator.translateId('search')" v-model="value">
    </div>
  </div>
</template>
<style scoped>
</style>
